import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {PrlDashboardComponent} from './components/prl-dashboard/prl-dashboard.component';
import {prlAuthentificationGuard} from '../../shared/services/prl-authentification-guard';
import {
    PrlMessageDialogComponent
} from './components/prl-dashboard-messages/prl-message-dialog/prl-message-dialog.component';
import {PrlPageGuard} from '../../shared/services/prl-page.guard';

const routes: Routes = [
    {
        path: 'dashboard',
        component: PrlDashboardComponent,
        canActivate: [prlAuthentificationGuard, PrlPageGuard],
        canActivateChild: [prlAuthentificationGuard],
        data: {pageName: 'Dashboard'}
    },
    {
        path: 'messages/:id',
        canActivate: [prlAuthentificationGuard, PrlPageGuard],
        component: PrlMessageDialogComponent,
        data: {pageName: 'Dashboard'}
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class PrlDashboardRoutingModule {
}
